import * as React from 'react'

import { Theme, useTheme } from '@emotion/react'

import * as tokens from '@cash-design-system/tokens'

import { CashAfterpayLogoSvg, CashAfterpayLogoSvgProps } from '../../icons/logos/CashAfterpayLogoSvg'

export type CashAfterpayLogoProps = Omit<CashAfterpayLogoSvgProps, 'logoColor' | 'textColor' | 'symbolColor'>

export const LOGO_VARIANTS = {
  logo: { light: tokens.ColorTintGreenLight, dark: tokens.ColorPaletteWhite },
  text: { light: tokens.ColorPaletteBlack, dark: tokens.ColorPaletteWhite },
  symbol: { light: tokens.ColorPaletteWhite, dark: tokens.ColorPaletteCobalt5 },
}

const getThemedColorValue = (theme: Theme, type: 'logo' | 'text' | 'symbol'): string => {
  return theme.darkMode ? LOGO_VARIANTS[type].dark : LOGO_VARIANTS[type].light
}

const CashAfterpayLogo = ({ altText, ...props }: CashAfterpayLogoProps) => {
  const theme = useTheme()

  return (
    <CashAfterpayLogoSvg
      {...props}
      data-testid="cash-afterpay-logo-component"
      altText={altText}
      logoColor={getThemedColorValue(theme, 'logo')}
      textColor={getThemedColorValue(theme, 'text')}
      symbolColor={getThemedColorValue(theme, 'symbol')}
    />
  )
}

export default CashAfterpayLogo
